import { usePageTitle } from "../components/usePageTitle";
import { contact } from "../content/site";

export default function Contact() {
  usePageTitle("Contact");
  return (
    <>
      <section className="page-head">
        <div className="wrap narrow center">
          <h1 className="display">here’s YOUR platform.</h1>
          <p className="section-title">Got a question? Want to talk? Let’s connect.</p>
        </div>
      </section>

      <section className="band">
        <div className="wrap split">
          <div>
            <h2 className="display">
              Drop by for a coffee, <em>give us a call,</em> or send us a note.
            </h2>
            <div className="contact-cards">
              <div>
                <h3 className="label">Visit</h3>
                <p>
                  {contact.street}
                  <br />
                  {contact.city}
                </p>
                <a className="text-link" href={contact.mapsHref} target="_blank" rel="noopener noreferrer">
                  Get directions
                </a>
              </div>
              <div>
                <h3 className="label">Say hi</h3>
                <p>
                  <a href={contact.phoneHref}>{contact.phone}</a>
                  <br />
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </p>
              </div>
              <div>
                <h3 className="label">Check us out</h3>
                <p>
                  {contact.social.map((s, i) => (
                    <span key={s.label}>
                      {i > 0 && " · "}
                      <a href={s.href} target="_blank" rel="noopener noreferrer">
                        {s.label}
                      </a>
                    </span>
                  ))}
                </p>
              </div>
            </div>
            <a className="btn" href={`mailto:${contact.email}`}>
              Email us
            </a>
          </div>
          <img className="rounded" src="/images/space-deck.jpg" alt="The covered deck at Platform 18" width="767" height="544" loading="lazy" />
        </div>
      </section>
    </>
  );
}
